import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import useStyles from './styles';

export default function Notifications() {
    const classes = useStyles();

    return (
        <>
            <ToastContainer
                className={classes.toast}
                autoClose={2000}
                closeOnClick
                position="bottom-right"
                hideProgressBar
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
            />
        </>
    );
}
